import React from 'react';
import {ApTooltip} from '@accurate-player/accurate-player-components-external';

import './Tooltip.scss';

ApTooltip.register();

export interface TooltipProps {
    headerText: string;
    text: string;
    setTooltipRef: () => void;
}

export default function Tooltip(props: TooltipProps) {
    const {
        text,
        headerText,
        setTooltipRef,
    } = props;
    
    return (
        <ap-tooltip
            position="static"
            class="tooltip"
            ref={setTooltipRef}
        >
            <p slot="header">
                {headerText}
            </p>
            <p>{text}</p>
        </ap-tooltip>
    );
}
